/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Suspense } from 'react';
import { useBexApi } from '@shared-ui/bex-api-context';

// Modules V1/V2/V3
import v1Modules from 'src/components/common/modules/v1';
import v2Modules from 'src/components/common/modules/v2';
import v3Modules from 'src/components/common/modules/v3';

//hooks
import useDetermineModuleVisibility from './meso-determine-module-visibility';

// Switch Modules
const switchModule = (lookupObject, expression) => (lookupObject[expression] || lookupObject['default'])();

// Module Mapper
// Key is coming from the CMS module name
// Value is the module

type ModulesType = {
  [key: string]: () => any;
};

const ModuleLoader = (moduleName, moduleProps) => {
  const modules = moduleName?.toLowerCase()?.startsWith('v3')
  ? v3Modules
  : moduleName?.toLowerCase()?.startsWith('v2')
  ? v2Modules
  : v1Modules;

  const ModuleComponent = switchModule(modules, moduleName);
  const { context } = useBexApi();

  const componentHTML = (
    <Suspense fallback={null}>
      <ModuleComponent {...moduleProps} />
    </Suspense>
  );

  return useDetermineModuleVisibility(context?.identity, moduleName, moduleProps, componentHTML);
};

const ItineraryModuleLoader = (moduleName, moduleProps) => {
  const modules = moduleName?.toLowerCase()?.startsWith('v3')
    ? v3Modules
    : moduleName?.toLowerCase()?.startsWith('v2')
    ? v2Modules
    : v1Modules;
  const ModuleComponent = switchModule(modules, moduleName);

  return (
    <Suspense fallback={null}>
      <ModuleComponent {...moduleProps} />
    </Suspense>
  );
};

export { ModuleLoader, ItineraryModuleLoader };